/**
 * 회원가입 본인인증 (/m/auth?type=join|social) — 이니시스 인증 창 → 가입폼 또는 소셜 연동
 * ($j.Pages.Mobile.SignupAuth / body data-page-name="SignupAuth")
 *
 * inicisCallback — 다른 창·앱이 부르는 약속이라 window 에 둔다.
 */
export default class SignupAuth {
    initialize() {
        const D = JSON.parse(document.getElementById('page-data')?.textContent || '{}');   // 서버 값 (#page-data)

        // 본인인증 생략(개발 서버)·인증 종류 — F/Inicis 와 아래 startInicis 가 G5 에서 읽는다
        G5['inicisByPass'] = D.inicisByPass;
        G5['inicisAuthType'] = D.type;

        (function () {
            let launching = false;   // 인증창을 연달아 여는 것을 막는다
            let saving = false;

            $(function () {
                $('#next-button').on('click', startInicis);
            });

            /**
             * 이니시스 인증 창 띄우기
             */
            function startInicis() {
                if (launching) return;
                launching = true;
                setTimeout(function () { launching = false; }, 2000);

                const type = G5['inicisAuthType'] === 'social' ? 'social' : 'join';
                const callbackUrl = $j.Common.Util.getHost() + `/m/plugin/inicis/callback/${type}`;
                $j.F.Inicis.auth({
                    successUrl: callbackUrl,
                    failUrl: callbackUrl,
                    type,
                });
            }

            /**
             * 이니시스 인증후 콜백 (인증 창이 부모창의 전역 inicisCallback 을 부른다)
             * @param data
             */
            window.inicisCallback = function (data) {
                if (!data || !data.result) {
                    $j.Common.Util.swalert((data && data.message) || '본인인증을 완료하지 못했습니다. 다시 시도해 주세요.');
                    return;
                }

                if (data.type === 'join') {
                    location.replace('/m/signup/form');
                } else if (data.type === 'social') {
                    socialAuthCallback(data);
                }
            };

            /**
             * 소셜회원이 최초로 이니시스 인증후
             * @param data
             */
            function socialAuthCallback(data) {
                switch (data.next) {
                    case 'J': // 미가입 — 폼 없이 바로 가입
                        saveSocial();
                        break;
                    case 'M': // 실명계정 있음 — 연동 여부를 묻는다 (거절할 수 있어야 한다)
                        $j.Common.Util.swalert('이미 가입된 장비불러 계정이 있어요.\n이 계정에 소셜 로그인을 연동할까요?', mergeSocial,
                            ['연동하기', '취소'], function () { location.replace('/m/login'); });
                        break;
                }
            }

            function mergeSocial() {
                $.ajax({ type: 'POST', url: '/m/ajax/member/merge', dataType: 'json' })
                    .done(function (r) {
                        if (r && r.result) {
                            $j.Common.Util.swalert('소셜 로그인이 연동되었습니다.', function () { location.replace('/m'); });
                        } else {
                            $j.Common.Util.swalert((r && r.message) || '계정을 연동하지 못했습니다. 로그인 화면에서 다시 시도해 주세요.',
                                function () { location.replace('/m/login'); });
                        }
                    })
                    .fail(function () {
                        $j.Common.Util.swalert('네트워크 오류로 연동하지 못했습니다. 잠시 후 다시 시도해 주세요.');
                    });
            }

            /**
             * 소셜 가입 저장
             */
            function saveSocial() {
                if (saving) return;
                saving = true;

                $.ajax({ url: '/m/ajax/member/join', type: 'post', dataType: 'json', data: { type: 'social' } })
                    .done(function (res) {
                        if (res && res.result) {
                            location.replace('/m/signup/complete');
                            return;
                        }
                        saving = false;
                        $j.Common.Util.swalert(((res && res.message) || '가입하지 못했습니다.') + '\n처음부터 다시 진행해 주세요.',
                            function () { location.replace('/m/login'); });
                    })
                    .fail(function () {
                        saving = false;
                        $j.Common.Util.swalert('네트워크 오류로 가입하지 못했습니다. 잠시 후 다시 시도해 주세요.');
                    });
            }
        })();

    }
}
